import { estimateConstants } from '../constants/actionTypes'
import * as opportunityService from '../services/opportunityService'
import { alertError } from './alertActions'

export const fetchIndividualEstimateRequest = () => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_REQUEST,
})

export const fetchIndividualEstimateSuccess = (
  estimate,
  estimateId,
  isGov,
  afterMarketAccessories,
  isProposal,
  proposalNumber,
  dateOfProposalAcceptance
) => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_SUCCESS,
  estimate,
  estimateId,
  isGov,
  afterMarketAccessories,
  isProposal,
  proposalNumber,
  dateOfProposalAcceptance,
})

export const fetchIndividualEstimateError = (errorMessage) => ({
  type: estimateConstants.FETCH_INDIVIDUAL_ESTIMATE_ERROR,
  errorMessage,
})

export function fetchIndividualEstimate(
  opportunityId,
  estimateId,
  isProposal,
  updateAnalytics,
  accessToken
) {
  return (dispatch) => {
    dispatch(fetchIndividualEstimateRequest())
    return opportunityService
      .fetchIndividualEstimate(opportunityId, estimateId, isProposal, updateAnalytics, accessToken)
      .then(
        (res) => {
          dispatch(
            fetchIndividualEstimateSuccess(
              res.quote,
              estimateId,
              res.parentOrganisationERCode,
              res.afterMarketAccessories,
              res.isProposal,
              res.proposalNumber,
              res.dateOfProposalAcceptance
            )
          )
        },
        (error) => {
          dispatch(fetchIndividualEstimateError(error, estimateId))
          dispatch(alertError(error))
        }
      )
  }
}
